<template>
    <div v-if="state !== 'READY'" class="overlay" :class="{overlayError: state === 'ERROR'}">
        <div class="overlay-container" :style="styles.overlayContainer">
            <div v-if="state === 'LOADING' || state === 'UPDATING'" class="loading-container">
                <fa v-if="iconToUse" class="spinner" :icon="iconToUse" size="3x" spin></fa>
                <div class="loading-message">{{ overlayMessage }}</div>
            </div>
            <div v-else-if="state === 'ERROR'" class="overlay-content">
                <fa v-if="iconToUse" :icon="iconToUse" size="2x" class="errorIcon"></fa>
                <div v-if="overlayMessage" class="overlay-message">
                    {{overlayMessage}}
                    <div class="reload-button" v-if="showReload" @click="reload">
                        <fa icon="sync"></fa>
                        Reload
                    </div>
                </div>
            </div>
            <div v-else-if="message" class="overlay-message">
                <fa v-if="iconToUse" :icon="iconToUse" size="2x"></fa>
                <div v-if="message !== null">{{ message }}</div>
                <slot></slot>
            </div>
            <div v-else>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
  import {ERROR, LOADING, UPDATING} from 'module/constants';

  export default {
    name: "overlay",
    props: {
      state: {
        type: String,
        default: null
      },
      message: {
        type: String,
        default: null
      },
      useStoreOnError: {
        type: Boolean,
        default: false
      },
      showOnSave: {
        type: Boolean,
        default: false
      },
      showReload: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: null
      },
      defaultIcon: {
        type: Boolean,
        default: false
      },
      styles: {
        type: Object,
        default: () => {
          return {
            overlayContainer: {},
            icon: {}
          };
        }
      }
    },
    computed: {
      errorMessage() {
        return this.$store.state.error.currentError ? this.$store.state.error.currentError.message : null;
      },
      iconToUse() {
        if (this.icon === null && [UPDATING, LOADING].indexOf(this.state) >= 0) {
          return 'spinner';
        } else if (this.icon === null && [ERROR].indexOf(this.state) >= 0) {
          return 'exclamation-circle';
        } else if (this.icon !== null) {
          return this.icon;
        } else {
          return null;
        }
      },
      overlayMessage() {
        if (this.state === ERROR && this.useStoreOnError === true && this.errorMessage !== null) {
          return this.errorMessage;
        } else if (this.state === LOADING && this.message === null) {
          return 'Loading...';
        } else {
          return this.message;
        }
      }
    },
    methods: {
      reload() {
        window.location.reload();
      }
    }
  }
</script>

<style lang="scss">
    @include overlay();
    .reload-button {
        background-color: $primary;
        text-align: center;
        color: white;
        margin: 10px auto 0 auto;
        padding: 10px;
        cursor: pointer;
        transition: all .2s ease;
        width: fit-content;
        font-size: .9em;

        &:hover {
            background-color: $primary-lighter;
        }
    }
</style>